import {
  collection,
  doc,
  getDoc,
  deleteDoc,
  getDocs,
  onSnapshot,
  query,
  serverTimestamp,
  setDoc,
  updateDoc,
  where
} from 'firebase/firestore';
import { db } from '../firebase';

export const REVIEW_MODERATOR_UID = 'o6WDuizp6BSlXPdbTXukZzkuJB32';
export const REVIEW_MAX_LENGTH = 500;

export function ratingDocId(userId, experienceId) {
  return `${userId}_${experienceId}`;
}

const EMPTY_STATS = { count: 0, total: 0, average: 0 };

export function subscribeRatingStats(experienceId, onData) {
  return onSnapshot(
    doc(db, 'ratingStats', experienceId),
    (snap) => {
      const data = snap.data() || {};
      onData({
        count: Number(data.count) || 0,
        total: Number(data.total) || 0,
        average: Number(data.average) || 0
      });
    },
    () => onData(EMPTY_STATS)
  );
}

export function subscribeMyRating(userId, experienceId, onData) {
  return onSnapshot(
    doc(db, 'ratings', ratingDocId(userId, experienceId)),
    (snap) => onData(snap.exists() ? snap.data() : null),
    () => onData(null)
  );
}

function timestampMillis(value) {
  if (!value) return 0;
  if (typeof value.toMillis === 'function') return value.toMillis();
  if (typeof value.seconds === 'number') return value.seconds * 1000;
  return 0;
}

export async function saveReview(userId, experienceId, reviewText) {
  const text = String(reviewText || '').slice(0, REVIEW_MAX_LENGTH);
  await updateDoc(doc(db, 'ratings', ratingDocId(userId, experienceId)), {
    reviewText: text,
    updatedAt: serverTimestamp()
  });
}

export async function clearReview(ratingId) {
  await updateDoc(doc(db, 'ratings', ratingId), {
    reviewText: '',
    updatedAt: serverTimestamp()
  });
}

export async function fetchPublicReviews(experienceId) {
  const snap = await getDocs(
    query(collection(db, 'publicReviews'), where('experienceId', '==', experienceId))
  );
  return snap.docs
    .map((item) => ({ id: item.id, ...item.data() }))
    .sort((a, b) => timestampMillis(b.createdAt) - timestampMillis(a.createdAt));
}

export async function deleteRating(userId, experienceId) {
  await deleteDoc(doc(db, 'ratings', ratingDocId(userId, experienceId)));
}

export async function saveRating(userId, experienceId, stars) {
  const ref = doc(db, 'ratings', ratingDocId(userId, experienceId));
  const existing = await getDoc(ref);
  if (existing.exists()) {
    await updateDoc(ref, { stars, updatedAt: serverTimestamp() });
    return;
  }
  await setDoc(ref, {
    userId,
    experienceId,
    stars,
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp()
  });
}
